import React from 'react';
import { connect } from 'react-redux';
import { CONFIG } from '../../../../../config';
import { cekCookies } from '../../../../../actions';
import { Alert, Modal } from 'react-bootstrap';
import __ from 'lodash';
import ReactExport from "react-data-export";
import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import accountManagement from '../../../../../apis/accountManagement';

class ImportGuru extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            error: null,
            isShowModalDownload: false,
            listGuru: [],
            alertType: 'success',
            resMessage: {},
            judul: 'Import Guru',
        }
    }

    async componentDidMount() {
        document.title = "Import Guru";

        this.setState({
            isFetching: true
        });

        await this.props.cekCookies();
        if(!__.isEmpty(this.props.account)) {
            // this.fetchKelas();
        }

        this.setState({
            isFetching: false
        });

        console.timeEnd('ImportGuru Time');
    }

    onFileChange = (event) => {
        console.clear();

        this.setState({
			file: event.target.files[0]
		});
    }

    handleSubmit = async (event)=> {
        event.preventDefault();
        console.clear();
        console.time('handleSubmit Time');
        this.setState({
            isFetching: true
        })

        if(this.state.file !== '') {
            let data = new FormData();
		    data.append('file', this.state.file);
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_GURU_IMPORT,
                data
            ).catch(function(error) {
                console.error('handleSubmit', error);
            })

            if(response) {
                if(response.data.data.type === 'existUsername') {
                    this.setState({
                        alertShow: response.data.data.status,
                        alertType: 'danger',
                        resMessage: 'Error, maaf username *' + response.data.data.keterangan + '* telah digunakan!',
                        file: '',
                        isFetching: false,
                    });
                }
                else if(response.data.data.type === 'import') {
                    if(response.data.data.status) {
                        this.setState({
                            alertShow: true,
                            alertType: 'success',
                            resMessage: response.data.data.keterangan,
                            listGuru: response.data.data.listGuru,
                            file: '',
                            isFetching: false,
                            isShowModalDownload: true
                        });
                    }
                    else {
                        this.setState({
                            alertShow: true,
                            alertType: 'danger',
                            resMessage: response.data.data.keterangan,
                            file: '',
                            isFetching: false,
                        });
                    }
                }
                else {
                    this.setState({
                        alertShow: true,
                        alertType: 'danger',
                        resMessage: response.data.errorSchema.errorMessage,
                        file: '',
                        isFetching: false,
                    });
                }

                document.getElementById("file").value = "";
            }
        }
        else {
            this.setState({
                isFetching: false
            });

            alert('Terjadi Kesalahan...');
        }
        console.timeEnd('handleSubmit Time');
    }

    resetState= async () =>{
        this.setState({isShowModalDownload : false, listGuru: []  });
        document.getElementById("file").value = "";
    }

    renderModalDownload(){
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
        return(
            
            <Modal 
                show={this.state.isShowModalDownload && !__.isEmpty(this.state.listGuru)}
                // onHide={() => this.setState({ })}
                aria-labelledby="example-custom-modal-styling-title"
                size="sm" backdrop="static" keyboard={false}>
                <Modal.Header style={{placeContent: 'center'}}>
                    <Modal.Title>
                        <ExcelFile element={<button className="btn btn-info" onClick={() => this.resetState()}><li className="fa fa-download"> Download Data</li></button>} filename= {"Guru "+this.props.account.namaUser} >
                            <ExcelSheet data={this.state.listGuru} name="Username Guru Sekolah">
                                <ExcelColumn label="Nama Guru" value="namaGuru"/>
                                <ExcelColumn label="Username" value="usernameGuru"/>
                                <ExcelColumn label="Password" value="passwordGuru"/>
                                <ExcelColumn label="No. Hp" value="handphoneGuru"/>
                            </ExcelSheet>
                        </ExcelFile>
                    </Modal.Title>
                </Modal.Header>
            </Modal>
        );
    }

    render() {
        console.groupCollapsed('Render ImportGuru State/Props');
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        return(
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{ paddingBottom: '50px' }}>
                    <Navbar />
                    <div className="row">
                        <div className="col-md-12">
                            <h4>{this.state.judul}</h4>
                        </div>
                    </div>

                    {this.loadAlert()}
                    {this.renderModalDownload()}
                    <div className="row">
                        <div className="col-md-5">
                            <div class="card">
                                <div class="card-body">
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-group">
                                            <label>File Excel <span className="text-danger">*</span></label>
                                            <input type="file" className="form-control" required onChange={this.onFileChange} id="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"/>
                                        </div>
                                        <br/>
                                        <button type="submit" value="Submit" className="btn btn-primary">
                                            <li className="fa fa-upload"> Upload</li>
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-7">
                            <div class="card">
                                <div class="card-body">
                                    <h5>Prosedur Import Guru :</h5>
                                    <ol>
                                        <li>
                                            Download format dokumen (.xlsx)&nbsp;
                                        </li>
                                        <li>
                                            Isi dokumen berdasarkan format yang sudah ditentukan
                                        </li>
                                        <li>Format dokumen wajib&nbsp;<span class="text-danger">
                                            <strong>*</strong></span><strong>.xlsx atau .xls</strong><span class="text-danger"><strong>*</strong></span>
                                        </li>
                                        <li>
                                            PASTIKAN TIDAK ADA IMPORT FILE LEBIH DARI 1 KALI, KARENA AKAN MENYEBABKAN DUPLIKASI AKUN ATAU MENYEBABKAN ERROR!!
                                        </li>
                                        <br/>
                                        <a class="btn btn-info pull-right" href={process.env.PUBLIC_URL + '/form_import_guru.xlsx'}>
                                            <li className="fa fa-download"> Download</li>
                                        </a>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loadAlert = () => {
        const { alertShow, alertType, resMessage } = this.state;

        if (alertShow) {
            return (
                <Alert variant={alertType} onClose={() => this.setState({ alertShow: false, alertType: 'success', resMessage: {} })} dismissible>
                    <strong>{resMessage}</strong>
                </Alert>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(ImportGuru);
